const playVideo = (videoWrap) => {
  videoWrap.innerHTML = '';

  var breakforMobile = '768';
  var screenWidth = window.innerWidth;

  var video = document.createElement('video');

  videoWrap.appendChild(video);

  var mobileVideo = videoWrap.getAttribute('data-mobile-video');
  var desktopVideo = videoWrap.getAttribute('data-desktop-video');
  var mobileQuality = videoWrap.getAttribute('data-mobile-quality');
  var desktopQuality = videoWrap.getAttribute('data-desktop-quality');
  var autoplay = videoWrap.getAttribute('data-autoplay');
  var controls = videoWrap.getAttribute('data-controls');
  var muted = videoWrap.getAttribute('data-muted');
  var loop = videoWrap.getAttribute('data-loop');
  var endpoint = videoWrap.getAttribute('data-endpoint');
  var defaultHost = videoWrap.getAttribute('data-defaultHost');

  !mobileQuality.length ? (mobileQuality = '240p') : null;
  !desktopQuality.length ? (desktopQuality = '240p') : null;

  video.setAttribute('preload', 'auto');
  if (controls === 'true') {
    video.controls = true;
  }
  if (muted === 'true') {
    video.muted = true;
  }
  if (loop === 'true') {
    video.loop = true;
  }

  var source1 = document.createElement('source');
  var source2 = document.createElement('source');

  var url = 'http://' + defaultHost + '/v/' + endpoint + '/';

  if (mobileVideo.length && screenWidth <= breakforMobile) {
    source1.setAttribute('src', url + mobileVideo + '/mp4_' + mobileQuality);
    source2.setAttribute('src', url + mobileVideo + '/webm_' + mobileQuality);
    if (autoplay === 'false') video.setAttribute('poster', url + mobileVideo);
  } else {
    //video.setAttribute('poster', url + desktopVideo);
    source1.setAttribute('src', url + desktopVideo + '/mp4_' + desktopQuality);
    source2.setAttribute('src', url + desktopVideo + '/webm_' + desktopQuality);
  }

  video.appendChild(source1);
  video.appendChild(source2);

  if (autoplay === 'true') {
    video.setAttribute('playsinline', true);
    var playPromise = video.play();

    if (playPromise !== undefined) {
      playPromise
        .then(function (_) {
          // Automatic playback started!
          // Show playing UI.
        })
        .catch(function (error) {
          // Auto-play was prevented
          // Show paused UI.
        });
    }
  }
};

export const initVideoChooser = () => {
  var hasVideoClass = !!document.getElementsByClassName('mul-dc-video-wrap');

  if (hasVideoClass) {
    var videoWrap = document.getElementsByClassName('mul-dc-video-wrap');

    for (let i = 0; i < videoWrap.length; i++) {
      playVideo(videoWrap[i]);
    }
  }
};
